export default {
  ecc: {
    title: 'Elastic Cloud Computing',
    pageHeader: 'Elastic Cloud Computing',
    // 实例
    instance: {
      name: 'Instances',
      purchaseBtn: 'Purchase ECC',
      // 搜索栏
      searchBar: {
        formPlaceholder: 'Search For ID /IP / Names',
        searchBtn: 'Search'
      },
      // 地区筛选
      locationFilter: {
        header: 'Location',
        placeholder: 'Select a region to filter'
      },
      // 实例列表
      dataList: {
        emptyTips: {
          noInstance: 'No Instances',
          guid: 'Deploy a new server at any of our worldwide datacenter locations.',
          recharge: 'Recharge Balance',
        },
        purchaseGuide: {
          tip: 'No data found, you can ',
          purchaseLink: ' create an instance'
        },
        columns: {
          name: 'Instance Name / IP',
          publicIp: 'Public IP',
          internalIp: 'Internal IP',
          intranet: 'Intranet',
          subnetMask: 'Subnet mask',
          gateway: 'Gateway',
          config: 'Config',
          os: 'OS',
          securityGroup: 'Security Groups',
          zone: 'Zone',
          createTime: 'Create Time',
          expireTime: 'Expiration Time',
          status: {
            header: 'Status',
            creating: 'Creating',
            installing: 'Installing',
            starting: 'Starting',
            running: 'Running',
            stopping: 'Stopping',
            stopped: 'Stopped',
            expiresSoon: 'Expiring soon',
            unknown: 'Unknown Status'
          },
          actions: 'Actions'
        },
        actions: {
          enabled: 'Enabled',
          disabled: 'Disabled',
          connect: 'Connect',
          renew: 'Renew',
          view: 'View',
          createSnapShot: 'Create Snapshot',
          addToIntranet: 'Add to Intranet',
          addReservedIp: 'Add Reserved IP',
          status: 'Instance Status',
          start: 'Start',
          stop: 'Stop',
          restart: 'Restart',
          upDowngrade: 'Upgrade / Downgrade',
          upgrade: 'Upgrade',
          downgrade: 'Downgrade',
          reinstall: 'Reinstall',
          resetPassword: 'Reset Password',
          rename: 'Rename',
          viewSnapshot: 'View Snapshot',
          addToSecurityGroup: 'Add To Security Group'
        },
        massActions: 'Mass Actions',
      },
      // 续费弹框
      renewDialog: {
        copySuccess: 'Copied to clipboard.',
        copyFail: 'Copy fail.',
        header: 'Renew',
        instanceCounter: '<span style="color:#37f;">#num#</span> instance#s# selected',
        summary: {
          name: 'Summary',
          publicIp: 'Public IP Address(es)',
          io: 'I/O Optimized',
          statusRunning: 'Running',
          statusStopped: 'Stopped',
          temporaryBandwidth: 'Temp'
        },
        duration: {
          header: 'Duration',
          month: 'Month',
          months: 'Months',
          year: 'Year',
          years: 'Years'
        },
        password: {
          header: 'Password',
          placeholder: 'Please enter the login password'
        },
        charges: {
          name: 'Price',
          headerProduct: 'Product',
          headerCharge: 'Charge',
          productServer: 'Servers',
          productDisk: 'Disks',
          productIp: 'IP'
        },
        buttons: {
          cancel: 'Cancel',
          pay: 'Pay',
          pending: 'Pending'
        }
      },
      // 添加到安全组弹框
      addToSecurityGroupDialog: {
        header: 'Add to Security Group',
        emptyGroupTips: {
          tip1: 'No Security Group, please ',
          tip2: 'create one'
        },
        groupSelector: {
          header: 'Select Security Group',
          placeholder: 'Please select a security group'
        },
        instanceSelector: {
          header: 'Selected Instance',
          instruction1: 'The rules of the selected security group will take effect automatically on the selected instance(s).',
          instruction2: 'If an instance is added to a security group for the first time, all ports are denied by default. Please add inbound rules as needed.'
        },
        buttons: {
          cancel: 'Cancel',
          add: 'Add'
        }
      },
      // 创建快照弹框
      createSnapshotDialog: {
        header: 'Create Snapshot',
        instance: {header: 'Related Instance'},
        disks: {
          header: 'Select Disk',
          search: 'Search'
        },
        tip: 'To ensure that the snapshot is created successfully, do not alter the instance status when the snapshot is being created, such as shutting down, restarting the instance or reinstalling, otherwise the creation will fail.',
        buttons: {
          cancel: 'Cancel',
          create: 'Create'
        }
      },
      // 加入内网弹框
      addToIntranetDialog: {
        header: 'Add to Intranet',
        selectedInstance: {
          instance: 'Instance',
          ip: 'Public IP'
        },
        intranetPicker: {
          header: 'Intranet'
        },
        ipPicker: {
          header: 'Select an Intranet IP'
        },
        noIntranetTips: {
          tip1: 'No Security Intranet, please',
          tip2: 'create one'
        },
        agreement: 'If it is checked, it will not shut down, and you need to enter the server to configure the intranet; if it is not checked, it will be shut down and configured automatically.',
        tip: 'When the instance is running , you can also log in to it to configure the intranet by yourself.',
        tip2: 'Please stop the instance so that we can configure the intranet for you.',
        buttons: {
          cancel: 'Cancel',
          add: 'Add'
        }
      },
      // 购买IP弹框
      buyIpDialog: {
        header: 'Add Reserved IP',
        quantity: 'Quantity',
        bandwidth: 'Bandwidth',
        duration: {
          header: 'Duration',
          month: 'Month',
          months: 'Months',
          year: 'Year',
          years: 'Years'
        },
        tips: {
          tip1: 'The upgrade is valid until #expireDate#, and the renewal fee of the next billing cycle is $ #amount#.',
          tip2: 'After purchasing IP, the server will restart automatically to complete binding.',
          tip3: 'IP can only be bound to ECS instances in the same zone.',
          tip4: 'Each instance can be bound to a maximum of 10 IPs.'
        },
        charges: {header: 'Price'},
        buttons: {
          cancel: 'Cancel',
          pay: 'Pay'
        }
      },
      // 关机弹框
      shutdownDialog: {
        header: 'Stop',
        selectedInstance: {
          countDesc: '<span style="color:#37f;">#num#</span> <span>instance</span> selected',
          statusStoppable: 'Stoppable',
          statusUnstoppable: 'Unstoppable'
        },
        tips: {
          tip1: 'Sure to shut down the server? During the shutdown, the host will not be able to provide service normally, please be prepared to avoid any impact.',
          tip2: 'Forced shutdown may result in data loss or file system corruption. Use it only when the server cannot be shut down normally.',
        },
        shutdownConfirmation: 'Confirm to use forced shutdown.',
        buttons: {
          cancel: 'Cancel',
          stop: 'Stop'
        }
      },
      // 开机弹框
      bootDialog: {
        header: 'Start',
        selectedInstance: {
          countDesc: '<span style="color:#37f;">#num#</span> <span>instance</span> selected',
          statusStartable: 'Startable',
          statusUnstartable: 'Unstartable'
        },
        buttons: {
          cancel: 'Cancel',
          start: 'Start'
        }
      },
      // 重启弹框
      rebootDialog: {
        header: 'Restart',
        selectedInstance: {
          countDesc: '<span style="color:#37f;">#num#</span> <span>instance</span> selected',
          statusRestartable: 'Restartable',
          statusNonrestartable: 'Non-Restartable'
        },
        tips: {
          tip1: 'Sure to restart the server? During the restart, the host will not be able to provide service normally, please be prepared to avoid any impact.',
          tip2: 'Forced shutdown may result in data loss or file system corruption. Use it only when the server cannot be shut down normally.'
        },
        restartConfirmation: 'Confirm to force restart.',
        buttons: {
          cancel: 'Cancel',
          restart: 'Restart'
        }
      },
      // 升降级弹框
      upDowngradeDialog: {
        header: {
          up: 'Upgrade',
          down: 'Downgrade'
        },
        headerMemory: 'RAM',
        headerBandwidth: 'Bandwidth',
        headerConfig: 'Configuration List',
        configColumns: {
          items: 'Items',
          current: 'Current',
          upgradeTo: 'Upgrade to',
          downgradeTo: 'Downgrade to',
          charges: 'Price',
          expireTime: 'Expiration time'
        },
        configRows: {
          bandwidth: 'Bandwidth',
          memory: 'Memory',
        },
        tips: {
          tip1: 'After expiration date #ended#, the renewal fee of next billing cycle is $ #monthAmount#.',
          tip2: '#operation# CPU and memory requires restarting the instance to take effect.',
          tip3: 'Bandwidth #operation# takes effect in real time'
        },
        operations: {
          upgrade: 'Upgrade',
          downgrade: 'Downgrade'
        },
        fee: {
          price: 'Price',
          reduce: 'Reduce'
        },
        buttons: {
          cancel: 'Cancel',
          done: 'Done'
        }
      },
      // 重装系统弹框
      reinstallDialog: {
        header: 'Reinstall Operating System',
        mirror: {
          header: 'Select mirror',
          os: 'OS'
        },
        account: {
          header: 'Account',
          user: {
            header: 'User'
          },
          password: {
            header: 'Password',
            tip: '8~16 characters, including uppercase and lowercase letters and numbers and special symbols [!?@#^&*()_+\\-=.] at the same time.'
          }
        },
        tips: {
          tip1: 'After reinstallation, all data in the system disk will be cleared and restored to the initial state..',
          tip2: 'The data disk purchased separately needs to be mounted manually before it can be used.',
          tip3: 'Reinstalling the system will delete the snapshots of the system disk and cannot be restored.'
        },
        buttons: {
          cancel: 'Cancel',
          reinstall: 'Reinstall'
        }
      },
      // 重置密码弹框
      resetPwdDialog: {
        header: 'Reset Password',
        n: {
          header: 'New Password',
          placeholder: 'Please enter a new password here',
          tip: '8~16 charaters. At least consists of 3 kinds of upper/lower-case letters, numbers, and special charaters (!@#^&*()_+-=).'
        },
        c: {
          header: 'Confirm Password',
          placeholder: 'Please enter a new password here'
        },
        tip: 'Caution: The server will restart after password changes, which may cause data loss or file system damage.',
        buttons: {
          cancel: 'Cancel',
          done: 'Done'
        }
      },
      // 重命名弹框
      renameDialog: {
        header: 'Rename',
        newName: {
          header: 'New Name',
          placeholder: 'Please enter a new Name here'
        },
        description: {
          header: 'Description'
        },
        buttons: {
          cancel: 'Cancel',
          rename: 'Rename'
        }
      },
      // 页面
      pages: {
        // 详情页
        detail: {
          tabs: {
            detail: 'Details',
            monitoring: 'Monitoring',
            operationLog: 'Operation Records'
          },
          tabDetail: {
            bandwidthSpeed: 'Current Internet Speed',
            cpuUsage: 'CPU Usage',
            currentCharges: 'Current Price',
            durationUnit: 'month',
            basicInfo: {
              header: 'Basic Information',
              name: 'Name',
              status: 'Status',
              description: 'Description',
              type: 'Type',
              zone: 'Zone',
              account: 'Account'
            },
            configInfo: {
              header: 'Configuration Information',
              memory: 'Memory',
              hardDisk: 'Hard Disk',
              os: 'OS',
              publicIp: 'Public IP',
              internalIp: 'Internal IP',
              bandwidth: 'Bandwidth'
            },
            otherInfo: {
              header: 'Current Price',
              createdAt: 'Created At',
              expiresAt: 'Expires At'
            }
          },
          tabMonitoring: {
            cpu: 'CPU(%)',
            memory: 'Memory Usage',
            disk: 'Disk Usage',
            diskCounters: {
              read: 'Read',
              write: 'Write',
              readRequests: 'Read Requests',
              writeRequests: 'Write Requests'
            },
            bandwidth: 'Bandwidth Usage',
            networkEvents: {
              in: 'In',
              out: 'Out',
              inPackets: 'In Packets',
              outPackets: 'Out Packets'
            },
            granularity: {
              day: 'Day',
              hour: 'Hour',
              min: 'min'
            },
          },
          tabOperationLog: {
            headerCols: {
              operation: 'Operation Name',
              operator: 'User Name',
              ip: 'IP Address',
              time: 'Operation Time'
            }
          }
        },
        loginPage: {header: 'Connect'}
      }
    },
    // 磁盘
    storage: {
      name: 'Storage',
      // 购买磁盘弹框
      purchaseDialog: {
        header: 'Purchase Storage',
        region: {header: 'Region/Zone:', regionPlaceholder: 'Please select a Region', zonePlaceholder: 'Please select a zone'},
        instance: {header: 'Related Instance', placeholder: 'Please select a instance to mount'},
        disk: {header: 'Disk Type', placeholder: 'Please select a disk type', types: {normal: 'Normal', he: 'High Performance'}},
        quantity: {header: 'Quantity', unit: 'Pieces'},
        capacity: {header: 'Capacity'},
        duration: {header: 'Duration', units: {month: 'Month', months: 'Months', year: 'Year', years: 'Years'}},
        charges: 'Price:',
        buttons: {cancel: 'Cancel', buy: 'Buy Now', pending: 'Pending'}
      },
      // 购买触发按钮
      purchaseTrigger: 'Purchase Storage',
      // 搜索栏
      searchBar: {placeholder: 'Search for Name or ECC ID', btn: 'Search'},
      // 地区过滤
      regionFilter: {header: 'Location'},
      // 列表
      list: {
        headerColumns: {
          name: 'Disk Name / ID',
          instance: 'Attached Instance',
          period: 'Validity Period',
          size: 'Size / Disk Capacity',
          diskTypes: {normal: 'Normal', he: 'High Performance'},
          logic: {yes: 'Yes', no: 'No'},
          zone: 'Zone',
          type: {header: 'Type', types: {system: 'System Disk', data: 'Data Disk'}},
          detachable: 'Detachable',
          status: {
            header: 'Status',
            statuses: {
              deleted: 'Deleted',
              unknown: 'Unknown',
              creating: 'Creating',
              unmounted: 'Unmounted',
              mounting: 'Mounting',
              inUse: 'In Use',
              unmounting: 'Unmounting',
              paused: 'Paused',
              expired: 'Expired'
            }
          },
          purchaseMethod: {
            header: 'Purchasing Method',
            methods: {
              systemDisk: 'System Disk',
              packaged: 'Data Disk in Package',
              separately: 'Independent Data Disk'
            }
          },
          action: {
            header: 'Actions',
            actions: {
              massAction: 'Mass Actions:',
              view: 'View',
              renew: 'Renew',
              createSnapshot: 'Create Snapshot',
              mount: 'Mount',
              unmount: 'Unmount',
              viewSnapshot: 'View Snapshot'
            }
          }
        }
      },
      regionLoadingTip: 'Region data is being fetching, please wait',
      // 创建快照弹框
      createSnapshotDialog: {
        header: 'Create Snapshot',
        disk: 'Disk ID:',
        ip: 'Public IP:',
        category: 'Category:',
        cateSys: 'System Disk',
        cateData: 'Data Disk',
        snapshotName: 'Snapshot Name:',
        placeholder: 'Please enter a new snapshot name here',
        tip: 'To ensure that the snapshot is created successfully, do not alter the instance status while creating the snapshot, such as shutting down, restarting, or reinstalling the instance, otherwise the creation will fail. Please wait.',
        btnCancel: 'Cancel',
        btnDone: 'Done'
      },
      // 续费弹框
      renewDialog: {
        header: 'Renew',
        selectedInstances: '<span>#num#</span> <span v-if="num>1">instance(s)</span> selected',
        renewable: 'renewable',
        duration: {
          header: 'Duration:',
          periods: {month: 'Month', months: 'Months', year: 'Year', years: 'Years'}
        },
        charges: 'Price',
        buttons: {cancel: 'Cancel', pay: 'Pay', pending: 'Pending'}
      },
      // 卸载弹框
      unmountDialog: {
        header: 'Disk Unmount',
        ask: 'Sure to unmount',
        agreement: 'After unmounting, the disk will not be able to provide services normally. Please be prepared to avoid any impact.',
        buttons: {cancel: 'Cancel', umount: 'Unmount'}
      },
      // 挂载弹框
      mountDialog: {
        header: 'Disk Mount',
        disk: 'Disk Object:',
        instance: 'Target Instance To Be Mounted:',
        buttons: {cancel: 'Cancel', mount: 'Mount'}
      },
      // 磁盘详情页
      detail: {
        createdAt: 'Created at',
        attachingInfo: {
          header: 'Attaching Information',
          attachTo: 'Attach To:',
          status: {header: 'Status:', unmounted: 'Unmounted', inUse: 'In Use', paused: 'Paused', expired: 'Expired'},
          mountPoint: 'Mount Point:',
          releaseWithIns: 'Release Disk With Instance:',
          followInstance: {yes: 'Yes', no: 'No'},
          action: {header: 'Actions', mount: 'Mount', unmount: 'Unmount', editDesc: 'Edit Description'}
        },
        serviceInfo: {
          header: 'Service Information',
          charges: 'Price:',
          durationUnit: 'mo',
          creationTime: 'Creation Time:',
          expirationTime: 'Expiration Time:',
          renew: 'Renew'
        },
        basicInfo: {
          header: 'Basic Information',
          diskName: 'Disk Name:',
          category: {header: 'Disk Category:', normal: 'Normal', hp: 'High Performance'},
          status: {header: 'Status:', unmounted: 'Unmounted', inUse: 'In Use', paused: 'Paused', expired: 'Expired'},
          size: 'Size:',
          detachable: {header: 'Detachable:', yes: 'Yes', no: 'No'},
          type: {header: 'Type:', sys: 'System Disk', data: 'Data Disk'},
          autoSnap: {header: 'Automatic Snapshot Switch:', yes: 'Yes', no: 'No'},
          createdAt: 'Created At:',
          desc: 'Disk Description:'
        }
      },
      // 编辑磁盘描述弹框
      editDescDialog: {
        header: 'Edit Description',
        name: {header: 'Disk Name:', tip: 'The length is limited to 6-30 characters. Start with letters and can contain numbers, ".", "_" or "-".'},
        desc: {header: 'Disk Description:', tip: 'Up to 200 characters and cannot start with http:// or https://.'},
        buttons: {cancel: 'Cancel', edit: 'Edit'}
      }
    },
    // 快照
    snapshot: {
      name: 'Snapshots',
      list: {
        searchBar: {placeholder: 'Snapshot Name / ID or ECC ID or Storage ID', btn: 'Search'},
        headerColumns: {
          name: 'Snapshot Name / ID',
          disk: 'Disk',
          creationTime: 'Creation Time',
          associatedServer: 'Related server',
          status: {header: 'Status'},
          action: {header: 'Actions', delete: 'Delete', rollback: 'Roll Back Disk', editTag: 'Edit Tag'}
        }
      },
      // 删除弹框
      deleteDialog: {
        header: 'Delete Snapshot',
        tip1: 'Sure to delete <span style="color:#37f;">#sn#</span> ?',
        tip2: 'After deletion, it cannot be restored. Please be cautious.',
        buttons: {cancel: 'Cancel', delete: 'Delete'}
      },
      // 回滚弹框
      rollbackDialog: {
        header: 'Roll Back Disk',
        notes: {
          one: 'The data on the system disk will be cleared. Please proceed with caution!',
          two: 'A disk can be rolled back only if the instance has been stopped and the current disk has no snapshot being created.',
          three: 'In order to ensure that the snapshot rollback is successful, please do not alter the instance status during the rollback, such as shutting down, restarting, or reinstalling the instance. Otherwise, the rollback will fail. Please wait patiently.',
        },
        options: {
          one: {
            one: 'Now shut down and roll back',
            two: 'Automatic shutdown (you must shut down first for immediate rollback)',
            three: 'Confirm to shut down immediately'
          },
          two: {
            one: 'Apply for rollback',
            two: 'Rollback takes time. After you apply for rollback, an email will be sent to you to remind you of the rollback. Then the system will automatically shut down and rollback.'
          },
          agreement: 'Restart the instance immediately after rollback',
          buttons: {cancel: 'Cancel', rollback: 'Roll back'}
        }
      },
      // 修改名称弹框
      editTagDialog: {
        header: 'Rename Snapshot',
        id: 'Snapshot ID:',
        oldName: 'Name:',
        newName: 'New Name:',
        placeholder: '',
        tip: 'Length is limited to 6-24 characters Start with letters and can contain numbers, "." and "_".',
        buttons: {cancel: 'Cancel', save: 'Save'}
      }
    },
    // 快照策略
    snapshotPolicy: {
      name: 'Snapshot Policies',
      createBtn: 'Create Snapshot Policy',
      // 创建快照策略弹框
      createDialog: {
        header: {create: 'Create Policy', edit: 'Edit Policy'},
        name: {header: 'Policy name:', placeholder: 'Please type the name of policy'},
        createdAt: 'Created At:',
        repeat: 'Repeat:',
        days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday'
        },
        retentionTime: {
          header: 'Retention time:',
          options: {
            one: {header: 'Custom duration', unit: 'Days (1 to 30)'},
            two: {header: 'Continue to keep until the number of snapshots reaches the maximum limit'}
          },
          notes: {
            one: 'Snapshot service allows you to create up to 64 automatic snapshots for a cloud disk. When the maximum number of automatic snapshots for a cloud disk has been reached, the system automatically deletes the earliest automatic snapshot when new snapshots are created.',
            two: 'If a disk contains a large amount of data, the time required to create a snapshot may be longer than the interval between two scheduled automatic snapshots. In these cases, the system will not create other snapshots until the ongoing snapshot creation task is complete. For example, assume that an automatic snapshot policy specifies that snapshots are created at 9:00, 10:00, and 11:00. If a snapshot creation task starts at 9:00 and lasts 70 minutes to end at 10:10, the system will create the next snapshot at 11:00, instead of 10:00.',
            three: 'The UTC+8 time zone is selected for the automatic snapshot policy.',
            four: 'If your account is overdue for more than 15 days, manual snapshots are deleted.',
            five: 'In order to ensure the success of snapshot creation, do not alter the status of the instance, such as stop or restart, while creating a snapshot. Please be patient.',
            expandBtn: 'more'
          }
        },
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 列表
      list: {
        searchBar: {placeholder: 'Search for Automatic Snapshot Policy', search: 'Search'},
        headerColumns: {
          name: 'Automatic Snapshot Policy',
          detail: 'Detail',
          detailRows: {
            executeTime: 'Executed At:',
            executeFrequency: 'Execution Frequency:',
            keepSnapshot: 'Keep Snapshot:'
          },
          relatedDisks: 'Related Disks',
          createTime: 'Creation Time',
          action: {
            header: 'Actions',
            modify: 'Modify',
            apply: 'Apply or Disable',
            delete: 'Delete'
          }
        }
      },
      // 删除弹框
      deleteDialog: {
        header: 'Delete Automatic Snapshot Policy',
        ask: 'Are you sure to delete automatic snapshot policy',
        tip: 'It cannot be restored after deletion. Please be cautious.',
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 应用策略弹框
      applyDialog: {
        header: 'Apply or Disable Automatic Snapshot Policy',
        tip: 'After an automatic snapshot policy is applied, the system automatically creates snapshots based on the policy settings, including the Executed At, Execution Frequency, and Keep Snapshots parameter settings.',
        tabs: {
          without: 'Disk Without Policy Applied',
          with: 'Disk With Policy Applied',
        },
        searchPlaceholder: 'Search for Disk ID/Name or Instance ID/Name',
        diskColumns: {
          name: 'Disk ID/Name',
          instance: 'Instance ID/Name',
          disk: 'Disk',
          action: {header: 'Actions', execute: 'Apply Policy', cancel: 'Cancel snapshot policy'}
        },
        diskCategories: {normal: 'Normal', hp: 'High Performance'},
        diskTypes: {sys: 'System Disk', data: 'Data Disk'},
        buttons: {close: 'Close'}
      }
    },
    // ip
    ip: {
      name: 'IP',
      purchaseBtn: 'Purchase Bandwidth',
      // 购买弹框
      purchaseDialog: {
        header: 'Add Reserved IP',
        instance: {header: 'Related Instance:', placeholder: 'Please select an instance to mount'},
        quantity: 'Quantity:',
        bandwidth: 'Bandwidth(M):',
        duration: {
          header: 'Duration:',
          units: {month: 'Month', months: 'Months', year: 'Year', years: 'Years'}
        },
        charges: 'Price',
        buttons: {cancel: 'Cancel', pay: 'Pay', pending: 'Pending'}
      },
      // 列表页
      list: {
        searchBar: {placeholder: 'Search for IP', search: 'Search'},
        regionFilter: {header: 'Location:', placeholder: 'Select a region to filter'},
        headerColumns: {
          status: {
            header: 'Status',
            statuses: {
              unbound: 'unbound',
              bound: 'bound',
              expired: 'expired'
            }
          },
          zone: 'Zone',
          boundServer: 'Bound Server',
          bandwidth: 'Bandwidth',
          purchasingMethod: {
            header: 'Purchasing Method',
            methods: {package: 'Package', separately: 'Independent'}
          },
          price: 'Price($/mo)',
          validity: 'Validity Period',
          action: {
            header: 'Actions',
            renew: 'Renew',
            bind: 'Bind',
            unbind: 'Unbind'
          }
        }
      },
      // 续费弹框
      renewDialog: {
        header: 'Renew',
        duration: {
          header: 'Duration:',
          units: {month: 'Month', months: 'Months', year: 'Year', years: 'Years'}
        },
        charges: 'Price:',
        buttons: {cancel: 'Cancel', pay: 'Pay', pending: 'Pending'}
      },
      // 解绑弹框
      unbindDialog: {
        header: 'Unbind',
        ask: 'Are you sure to unbind <span style="color:#37f;">#ip#</span>?',
        instance: 'Related Instance',
        tip: 'Unbind IP will restart instance. Please make sure that the data has been saved. Unbinding IP may affect your business. Please be prepared in advance.',
        buttons: {cancel: 'Cancel', unbind: 'Unbind'}
      },
      // 绑定弹框
      bindDialog: {
        header: 'Bind',
        ip: 'IP Address',
        instancePickerTip: 'Please select an instance that the ip bind to:',
        searchPlaceholder: 'Search',
        units: {cpu: 'vCore(s)', memory: 'Mem'},
        statuses: {
          creating: 'Creating',
          initializing: 'Initializing',
          starting: 'Starting',
          running: 'Running',
          stopping: 'Stopping',
          stopped: 'Stopped',
          expiringSoon: 'Expiring soon',
          unknown: 'Unknown status'
        },
        buttons: {cancel: 'Cancel', bind: 'Bind'}
      }
    },
    // 安全组
    securityGroup: {
      name: 'Security Groups',
      createBtn: 'Create Security Group',
      // 创建/编辑弹框
      createDialog: {
        header: 'Create Security Group',
        editHeader: 'Edit Security Group',
        name: {header: 'Name', placeholder: 'Please type the name of security group'},
        tag: {header: 'Tag', placeholder: 'Please type the name of tag'},
        desc: 'Description',
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 删除弹框
      deleteDialog: {
        header: 'Delete Security Group',
        ask: 'Are you sure to delete',
        instance: {
          header: 'List of selected security groups',
          selected: '<span style="color:#37f;">#num#</span>&nbsp;<span style="color:#37f;" v-if="num > 1">instance#s#</span> selected'
        },
        buttons: {cancel: 'Cancel', delete: 'Delete'}
      },
      // 列表
      list: {
        searchBar: {placeholder: 'Search for ID / Name', search: 'Search'},
        headerColumns: {
          id: 'ID',
          name: 'Name',
          tag: 'Tag',
          relatedInstances: 'Related Instances',
          createTime: 'Creation Time',
          action: {
            header: 'Actions',
            configure: 'Configure',
            edit: 'Edit',
            delete: 'Delete',
            deleteTip: 'Please remove the related instance(s) before deleting security group.',
            massAction: 'Mass Actions:'
          }
        }
      },
      // 配置页
      configure: {
        tabs: {inboundRules: 'Inbound Rules', manageInstances: 'Manage Instances'},
        headButtons: {addRule: 'Add Rules', addInstance: 'Add Instances'},
        ruleHeaderColumns: {
          id: 'ID / Security Group Name',
          authorizationObject: 'Authorization Object',
          protocolType: 'Protocol Type',
          portRange: 'Port Range',
          action: 'Action',
          desc: 'Description',
          priority: 'Priority',
          actions: {header: 'Actions', modify: 'Modify', delete: 'Delete'}
        },
        insHeaderColumns: {
          id: 'Instance ID',
          name: 'Name',
          ip: 'IP Address',
          zone: 'Zone',
          actions: {header: 'Actions', remove: 'Remove'}
        },
        noInsTip: 'Please add an instance to a security group in the instance list',
        massAction: 'Mass Actions:'
      },
      // 删除规则弹框
      deleteRuleDialog: {
        header: 'Delete Rule',
        ask: 'Are you sure to delete',
        selectedRules: 'Selected rules:',
        selectedCount: '<span style="color:#37f;">#num#</span> <span style="color:#37f;">rule#s#</span> selected',
        buttons: {cancel: 'Cancel', delete: 'Delete'}
      },
      // 修改规则弹框
      editRuleDialog: {
        header: 'Modify Rule',
        protocolType: {
          header: 'Protocol Type',
          placeholder: 'Please select',
          options: {
            all: 'All',
            customTcp: 'Custom TCP',
            customUdp: 'Custom UDP'
          }
        },
        authObj: {
          header: 'Authorization Object',
          tip: 'All IP (0.0.0.0), Single IP (10. x.x.y), IP segment (x.y.z.0 / 24), Multiple IP (10. x.y.z, 11. x.y.z, 12. x.y.z)',
          placeholder: 'Please type the name of rule'
        },
        portRange: {
          header: 'Port Range',
          tip: 'Single port (22), Port range (10 / 20), All ports (- 1 / - 1)'
        },
        action: {
          header: 'Action',
          options: {
            allowed: 'Allowed',
            notAllowed: 'Not Allowed'
          }
        },
        desc: 'Description',
        priority: {
          header: 'Priority',
          tip: 'From 1 to 99',
          placeholder: 'Please type the priority'
        },
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 添加规则弹框
      addRuleDialog: {
        header: 'Add Inbound',
        tips: {
          one: 'When you join a security group for the first time, all ports are rejected by default. Please add permission rules as needed',
          two: 'Source format: All IP (0.0.0.0),Single IP (10. x.x.y),IP segment (x.y.z.0 / 24),Multiple IP (10. x.y.z, 11. x.y.z, 12. x.y.z)',
          three: 'Port format: Single port (22), Port range (10 / 20), All ports (- 1 / - 1)',
          four: 'Priority: From 1 to 99, the smaller the number, the higher the priority.'
        },
        headerColumns: {
          protocolType: 'Protocol Type',
          authObj: {header: 'Authorization Object', placeholder: 'eg:0.0.0.0/0'},
          portRange: {header: 'Port Range', placeholder: 'Please fill in'},
          action: {header: 'Action', options: {allow: 'Allow', reject: 'Reject'}},
          remark: {header: 'Remark', placeholder: 'Pleas fill in'},
          priority: {header: 'Priority', placeholder: 'Pleas fill in'},
          actions: {header: 'Actions', delete: 'Delete'}
        },
        appendBtn: 'Add',
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 绑定实例弹框
      bindInstanceDialog: {
        header: 'Add into Security Group',
        selectedGroup: 'Selected Security Group: ',
        placeholder: 'Input Name, ID or IP to search',
        headerColumns: {
          instance: 'Instance ID/Name',
          intranet: 'Intranet',
          ip: 'IP Address',
          public: ' (Public)'
        },
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      }
    },
    // 内网
    intranet: {
      name: 'Intranet',
      // 创建弹框
      createDialog: {
        header: {create: 'Create Intranet', edit: 'Edit'},
        name: {header: 'Name:', placeholder: 'Please type the name of intranet'},
        desc: 'Description:',
        networkSegment: 'Network Segment:',
        buttons: {cancel: 'Cancel', confirm: 'Confirm'}
      },
      // 列表
      list: {
        searchBar: {placeholder: 'Search for IP / Name', search: 'Search'},
        headerColumns: {
          networkSegment: 'Network Segment',
          name: 'Name',
          desc: 'Description',
          createTime: 'Creation Time',
          actions: {header: 'Actions', view: 'View', edit: 'Edit'}
        },
        tips: {
          one: '<span style="font-weight:bold;">Secure Isolation:</span><br>Builds an isolated network environment based on Yisu Cloud. Layer-2 logical isolation is achieved between different intranets.',
          two: '<span style="font-weight:bold;">Flexibility:</span><br>Software-defined network (SDN) configures the network as required, customizes the IP address range and route table.',
          three: '<span style="font-weight:bold;">Free of Charge:</span><br>Achieve a fully isolated intranet environment for free on the Yisu Cloud platform.',
          four: '<span style="font-weight:bold;">Application:</span><br>Cloud servers in one zone can access each other through intranets while those in different zones cannot.'
        }
      },
      // 详情页
      detail: {
        title: 'Intranet:',
        subTitle: 'Intranet:',
        headerColumns: {
          zone: 'Zone',
          name: 'Name',
          configuration: 'Configuration'
        },
        units: {core: 'vCore(s)'},
        notes: {
          one: '<span style="font-weight:bold;">Secure Isolation:</span><br>Builds an isolated network environment based on Yisu Cloud. Layer-2 logical isolation is achieved between different intranets.',
          two: '<span style="font-weight:bold;">Flexibility:</span><br>Software-defined network (SDN) configures the network as required, customizes the IP address range and route table.',
          three: '<span style="font-weight:bold;">Free of Charge:</span><br>Achieve a fully isolated intranet environment for free on the Yisu Cloud platform.',
          four: '<span style="font-weight:bold;">Application:</span><br>Cloud servers in one zone can access each other through intranets while those in different zones cannot.'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/ecc.js